function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "SVGID",
  width: 57.392,
  height: 50.667
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(754.413 -1246.719)"
}, React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(-754.413 1246.719)"
}, React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18",
  clipPath: "url(#clip-path)"
}, React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 45.094,
  height: 8.199,
  transform: "translate(12.859 21.244)"
}), React.createElement("rect", {
  id: "Rectangle_2",
  "data-name": "Rectangle 2",
  width: 45.094,
  height: 8.199,
  transform: "translate(12.859 42.442)"
}), React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 45.094,
  height: 8.199,
  transform: "translate(12.859 0.046)"
}))), React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 8.199,
  height: 8.199,
  transform: "translate(-754.273 1246.764)"
}), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 8.199,
  height: 8.199,
  transform: "translate(-754.273 1267.963)"
}), React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 8.199,
  height: 8.199,
  transform: "translate(-754.273 1289.161)"
}));

var SvgListView1 = function SvgListView1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 57.392,
    height: 50.667,
    viewBox: "0 0 57.392 50.667",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListView1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_view-1.0909914e.svg";
export { ForwardRef as ReactComponent };